import angular from 'angular';

import { FluxoAprovacoesListRouting } from './fluxoaprovacoes.routes';

import { FluxoAprovacoesService } from './fluxoaprovacoes.service';

import { FluxoAprovacoesIndexController } from './index/fluxoaprovacoes.index.controller';
import { ModalFluxoAprovacoesService } from './modal/fluxoaprovacoes.modal.service';
import { ModalFluxoAprovacoesController } from './modal/fluxoaprovacoes.modal.controller';
import { FluxoAprovacoesConfirmModalService } from './modal/confirm/fluxoaprovacoesconfirm.modal.service';
import { FluxoAprovacoesConfirmModalController } from './modal/confirm/fluxoaprovacoesconfirm.modal.controller';
import { ConfigurarLoteModalController } from './modal/configurarLote/configurarlote.modal.controller';
import { ConfigurarLoteModalService } from './modal/configurarLote/configurarlote.modal.service';

export const FluxoAprovacoesModule = angular.module('FluxoAprovacoesModule', ['ui.router.state', ])
    .controller('FluxoAprovacoesIndexController', FluxoAprovacoesIndexController)
    .controller('ModalFluxoAprovacoesController', ModalFluxoAprovacoesController)
    .controller('FluxoAprovacoesConfirmModalController', FluxoAprovacoesConfirmModalController)
    .controller('ConfigurarLoteModalController', ConfigurarLoteModalController)
    .service('FluxoAprovacoesService', FluxoAprovacoesService)
    .service('ModalFluxoAprovacoesService', ModalFluxoAprovacoesService)
    .service('FluxoAprovacoesConfirmModalService', FluxoAprovacoesConfirmModalService)
    .service('ConfigurarLoteModalService', ConfigurarLoteModalService)
    .config(FluxoAprovacoesListRouting)
    .name;
